import Auth from '../auth/Auth';
import SystemConfig from '../models/SystemConfig';
import { WebClient } from './WebClient'

class ApiSystemConfig extends WebClient {
    async getSystemConfigs(): Promise<SystemConfig[]> {
        const url = "/config";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateSystemConfigs(data: SystemConfig[]): Promise<boolean> {
        return this.put("/config", data, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }
}

export default new ApiSystemConfig();
